export default __webpack_public_path__ + "static/highlight-1-a2a1a6fb7050cec6a0f3e4055b3a1de9.svg";